import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../service/auth-guard.service';
import { AdditionalContentPageComponent } from '../component/page/additional-content-page/additional-content-page.component';
import { CookiesPolicyPageComponent } from '../component/page/cookies-policy-page/cookies-policy-page.component';

const routes: Routes = [
  { path: 'page/Cookies', component: CookiesPolicyPageComponent },
  { path: 'page/Supported-21.3-Offer-Management-Flows', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: 'Supported-21.3-Offer-Management-Flows' } },
  { path: 'page/Supported-21.3-Order-Management-Flows', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: 'Supported-21.3-Order-Management-Flows' } },
  { path: 'page/Supported-21.3-Disruption-Handling-Flows', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: 'Supported-21.3-Disruption-Handling-Flows' } },
  { path: 'page/21.3-Time-Limits', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: '21.3-Time-Limits' } },
  { path: 'page/British-Airways-NDC-21.3-Pilot-Agent-Onboarding-Guide', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: 'British-Airways-NDC-21.3-Pilot-Agent-Onboarding-Guide' } },
  { path: 'page/OrderChangeNotification-API-17.2-vs-21.3-Comparison', component: AdditionalContentPageComponent, canActivate: [AuthGuardService], data: { pageTitle: 'OrderChangeNotification-API-17.2-vs-21.3-Comparison' } },
  { path: 'page/:pageTitle', component: AdditionalContentPageComponent },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppAdditionalRoutingModule {}
